import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useCart } from "@/context/CartContext";
import { inr } from "@/lib/api";

export default function ProductCard({ product, index = 0 }) {
  const { add } = useCart();
  return (
    <Reveal delay={(index % 3) * 0.08} className="group" data-testid={`product-card-${product.slug}`}>
      <Link to={`/product/${product.slug}`} className="block">
        <div className="relative overflow-hidden bg-sand aspect-[4/5]">
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
          />
          <span className="absolute top-4 left-4 bg-cream/85 backdrop-blur-sm px-3 py-1 font-sans uppercase tracking-[0.2em] text-[10px] text-obsidian/70">
            {product.system}
          </span>
        </div>
      </Link>
      <div className="mt-5 flex items-start justify-between gap-4">
        <div>
          <p className="font-sans uppercase tracking-[0.2em] text-[10px] text-amber-deep">{product.category}</p>
          <Link to={`/product/${product.slug}`}>
            <h3 className="mt-1 font-serif text-2xl leading-tight text-obsidian">{product.name}</h3>
          </Link>
          <p className="mt-1 font-sans font-light text-sm text-obsidian/55">{product.tagline}</p>
        </div>
        <span className="font-serif text-xl text-obsidian shrink-0">{inr(product.price)}</span>
      </div>
      <button
        data-testid={`add-cart-${product.slug}`}
        onClick={() => add(product)}
        className="mt-4 w-full inline-flex items-center justify-center gap-2 border border-obsidian/20 py-3 font-sans uppercase tracking-[0.2em] text-[11px] hover:bg-obsidian hover:text-cream transition-colors"
      >
        <Plus className="w-3.5 h-3.5" /> Add to cart
      </button>
    </Reveal>
  );
}
